export interface PolicyMeta {
  slug: string;
  title: string;
  path: string;
  summary: string;
}

/** First production release date — update only when a policy is substantively revised. */
export const POLICY_EFFECTIVE_DATE = "16 July 2026";
/** Bumped 2026-09-13: Terms/Privacy/Cancellation/Refunds/Acceptable Use activated to reflect live Devory Cloud billing -- a substantive revision, not a typo fix. */
export const POLICY_LAST_UPDATED = "13 September 2026";

export const policies: PolicyMeta[] = [
  {
    slug: "terms",
    title: "Terms of Service",
    path: "/legal/terms",
    summary: "The rules for using the Devory website and Devory Cloud.",
  },
  {
    slug: "privacy",
    title: "Privacy Policy",
    path: "/legal/privacy",
    summary: "What information Devory collects from visitors and customers, and why.",
  },
  {
    slug: "refunds",
    title: "Refund Policy",
    path: "/legal/refunds",
    summary: "How refunds are handled for paid Devory Cloud subscriptions.",
  },
  {
    slug: "cancellation",
    title: "Cancellation Policy",
    path: "/legal/cancellation",
    summary: "How to cancel a paid Devory Cloud subscription.",
  },
  {
    slug: "acceptable-use",
    title: "Acceptable Use Policy",
    path: "/legal/acceptable-use",
    summary: "What is prohibited when using Devory, and how violations are handled.",
  },
  {
    slug: "cookies",
    title: "Cookie Policy",
    path: "/legal/cookies",
    summary: "What cookies and local storage this website currently uses.",
  },
];

export function relatedPolicies(currentSlug: string): PolicyMeta[] {
  return policies.filter((policy) => policy.slug !== currentSlug);
}
